/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ====== Smart Header: hide on scroll down, reveal on scroll up ======
  var SCROLL_THRESHOLD = 80; // px from top — header always stays visible above this

  document.addEventListener('theme:scroll', function(e) {
    var header = document.querySelector('.js__header__stuck');
    if (!header) return;

    var position = e.detail.position;

    if (position <= SCROLL_THRESHOLD) {
      // At (or near) the very top — always show
      header.classList.remove('header--scroll-hide');
    } else if (e.detail.down) {
      // Scrolling DOWN — hide the header
      header.classList.add('header--scroll-hide');
    } else if (e.detail.up) {
      // Scrolling UP — reveal the header
      header.classList.remove('header--scroll-hide');
    }
  });
  // ====== End Smart Header ======

  // ====== Sort nav button → open filter/sort sidebar ======
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-open-sidebar]');
    if (!btn) return;
    e.preventDefault();
    // Programmatically click the real filter toggle so Broadcast handles sidebar state correctly
    var filterToggle = document.querySelector('[data-aria-toggle][aria-controls="filter-groups"]');
    if (filterToggle) filterToggle.click();
  });
  // ====== End Sort nav button ======

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


// ====== Collection Load More ======
// Runs independently — works with or without the Collection Tabs section.
(function () {

  var gridOuter    = document.querySelector('[data-products-grid]');
  var loadMoreWrap = document.querySelector('[data-load-more-wrapper]');
  var loadMoreBtn  = document.querySelector('[data-load-more-btn]');

  if (!gridOuter || !loadMoreWrap) return;

  // Read config from Collection Tabs section if it exists; otherwise use defaults.
  function getConfig() {
    var tabsEl = document.querySelector('[data-collection-tabs]');
    if (tabsEl) {
      var id  = tabsEl.dataset.sectionId;
      var cfg = (window.__collectionTabsConfig || {})[id] || {};
      return {
        desktopInitial: cfg.loadMoreDesktop     || 16,
        mobileInitial:  cfg.loadMoreMobile      || 6,
        desktopStep:    cfg.loadMoreStepDesktop || 4,
        mobileStep:     cfg.loadMoreStepMobile  || 2
      };
    }
    return { desktopInitial: 16, mobileInitial: 6, desktopStep: 4, mobileStep: 2 };
  }

  function isMobile() { return window.innerWidth < 750; }

  // Expose so Collection Tabs can call after AJAX update
  window.__applyCollectionLoadMore = function () {
    var cfg     = getConfig();
    var initial = isMobile() ? cfg.mobileInitial : cfg.desktopInitial;
    var items   = Array.from(gridOuter.querySelectorAll('.grid-item'));

    items.forEach(function (item, idx) {
      if (idx < initial) {
        item.style.display = '';
        item.removeAttribute('data-lm-hidden');
      } else {
        item.style.display = 'none';
        item.setAttribute('data-lm-hidden', '');
      }
    });

    var hidden = gridOuter.querySelectorAll('.grid-item[data-lm-hidden]').length;
    loadMoreWrap.style.display = hidden > 0 ? 'block' : 'none';
  };

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      var cfg         = getConfig();
      var step        = isMobile() ? cfg.mobileStep : cfg.desktopStep;
      var hiddenItems = Array.from(gridOuter.querySelectorAll('.grid-item[data-lm-hidden]'));

      hiddenItems.slice(0, step).forEach(function (item) {
        item.style.display = '';
        item.removeAttribute('data-lm-hidden');
      });

      var stillHidden = gridOuter.querySelectorAll('.grid-item[data-lm-hidden]').length;
      loadMoreWrap.style.display = stillHidden > 0 ? 'block' : 'none';
    });
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.__applyCollectionLoadMore);
  } else {
    window.__applyCollectionLoadMore();
  }

})();
// ====== End Collection Load More ======


// ====== Collection Tabs ======
// Requires the Collection Tabs section to be on the page.
(function () {

  var tabsEl = document.querySelector('[data-collection-tabs]');
  if (!tabsEl) return;

  var productsSec = document.querySelector('[data-tab-products-section]');
  var gridOuter   = productsSec && productsSec.querySelector('[data-products-grid]');
  var loadMoreWrap = document.querySelector('[data-load-more-wrapper]');

  if (!productsSec || !gridOuter) return;

  var tabs           = Array.from(tabsEl.querySelectorAll('[data-tab-handle]'));
  var currentHandle  = 'all';

  function setActiveTab(activeBtn) {
    tabs.forEach(function (t) {
      t.classList.remove('ctabs__tab--active');
      t.setAttribute('aria-selected', 'false');
    });
    activeBtn.classList.add('ctabs__tab--active');
    activeBtn.setAttribute('aria-selected', 'true');
  }

  function switchTab(btn) {
    var handle = btn.dataset.tabHandle;
    if (handle === currentHandle) return;
    currentHandle = handle;
    setActiveTab(btn);

    // Loading state
    gridOuter.classList.add('ctabs--loading');
    if (loadMoreWrap) loadMoreWrap.style.display = 'none';

    fetch('/collections/' + handle + '?sections=collection')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || !data['collection']) throw new Error('No section data');
        var parser = new DOMParser();
        var doc    = parser.parseFromString(data['collection'], 'text/html');
        var newGrid = doc.querySelector('[data-products-grid]');
        if (newGrid) {
          gridOuter.innerHTML = newGrid.innerHTML;
        }
        // Update product count in nav
        var newCount     = doc.querySelector('[data-product-count]');
        var currentCount = document.querySelector('[data-product-count]');
        if (newCount && currentCount) {
          currentCount.textContent = newCount.textContent;
        }
      })
      .catch(function (err) {
        console.warn('[Collection Tabs] Fetch failed:', err);
      })
      .then(function () {
        // Always runs after both success and catch
        gridOuter.classList.remove('ctabs--loading');
        if (typeof window.__applyCollectionLoadMore === 'function') {
          window.__applyCollectionLoadMore();
        }
        var top = productsSec.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
  }

  tabs.forEach(function (btn) {
    btn.addEventListener('click', function () { switchTab(btn); });
  });

})();
// ====== End Collection Tabs ======
